module.exports = __webpack_public_path__ + "static/media/memories-Text.18ebdb6d.png";